import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, {
  IActionData,
  ITableColumn,
} from '@/components/common/CommonTable';
import MainHeading from '@/components/common/MainHeading';
import EditIcon from '@/components/Icons/EditIcon';
import PlusIcon from '@/components/Icons/PlusIcon';
import Layout from '@/components/Layout/Layout';
import ConfirmModal from '@/components/Modal/ConfirmModal';
import { getFilterUrl, showToastNotification } from '@/utility/helper';
import moment from 'moment';
import { useEffect, useState } from 'react';
import {
  IHolidayModal,
  IHolidayPageState,
  IHolidayResponse,
  IHolidayState,
} from '@/interfaces/holiday.model';
import AddHolidayModal from '@/components/Modal/AddHolidayModal';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import CardLayout from '@/components/Layout/CardLayout';
import useFilter from '@/hooks/useFilter';
import { RootState } from '@/redux/store';
import { useSelector } from 'react-redux';
import DeleteIcon from '@/components/Icons/DeleteIcon';
export interface ITableData {
  id: string;
  dateOfHolidays: string;
  holidayName: string;
  description: string;
  holidayDate?: string;
}

const HolidaySetting = () => {
  const [modal, setModal] = useState<IHolidayModal>({
    updateData: false,
    deleteData: false,
  });
  const [selectedMonth, setSelectedMonth] = useState<number>(
    new Date().getMonth(),
  );
  const [selectedYear, setSelectedYear] = useState<number>(
    new Date().getFullYear(),
  );
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const [state, setState] = useState<IHolidayState>({
    leaveCount: null,
    holidayList: [],
    EditHolidaysData: null,
  });
  const [pageStates, setPageStates] = useState<IHolidayPageState>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    filterData: '',
    searchQuery: '',
    startDate: moment(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    ).format('YYYY-MM-DD'),
    endDate: moment(
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    ).format('YYYY-MM-DD'),
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>('');
  const toggleModal = (type?: string) => {
    setModal((pre) => ({
      ...pre,
      ...(type === 'delete'
        ? { deleteData: !pre.deleteData }
        : { updateData: !pre.updateData }),
    }));
  };
  const tableHeading: ITableColumn<ITableData>[] = [
    { value: 'dateOfHolidays', label: 'Date of Holidays' },
    { value: 'holidayName', label: 'Holiday Name' },
    { value: 'description', label: 'Description' },
  ];

  const getHoliday = async () => {
    try {
      const filterState = {
        pageSize: filterDetails?.pageSize,
        pageNumber: pageStates?.currentPage,
        startDate: pageStates?.startDate,
        endDate: pageStates?.endDate,
        search: pageStates?.searchQuery,
      };
      const API = `${API_URL}${API_ENDPOINT?.getHoliday}?${getFilterUrl(filterState)}`;
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      const response: IHolidayResponse = await callApi(API, {
        method: 'GET',
      });
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      if (response?.status === true) {
        const newData: ITableData[] = response?.data?.map((item) => ({
          ...item,
          holidayDate: item.holidayDate,
          dateOfHolidays: moment(item.holidayDate).format('DD/MM/YYYY'),
        }));
        setState((pre) => ({
          ...pre,
          holidayList: newData,
        }));
        // setPageStates((pre) => ({
        //   ...pre,
        //   count: response?.data?.pageInfo?.total,
        //   totalPages: response?.data?.pageInfo?.totalPages,
        // }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
    }
  };

  useEffect(() => {
    getHoliday();
  }, [
    pageStates?.startDate,
    pageStates?.endDate,
    pageStates?.searchQuery,
    filterDetails.pageSize,
  ]);

  const HandleDelete = async () => {
    setIsLoading(true);
    try {
      const API = `${API_URL}${API_ENDPOINT.deleteHoliday}?holidayId=${selectedId}`;
      const response: IHolidayResponse = await callApi(API, {
        method: 'GET',
      });
      setIsLoading(false);
      if (response?.status === true) {
        showToastNotification('success', response?.message);
        toggleModal('delete');
        getHoliday();
      } else {
        showToastNotification('danger', response?.message);
        toggleModal('delete');
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  };

  const handleChangePageSize = (value: number) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const handleEdit = (data: ITableData): void => {
    const editData = {
      ...data,
      holidayDate: moment(data.dateOfHolidays, 'DD/MM/YYYY').format(
        'YYYY-MM-DD',
      ),
    };
    setState((pre: IHolidayState) => ({ ...pre, EditHolidaysData: editData }));
    toggleModal();
  };
  const ActionHandler = (data: ITableData) => {
    setSelectedId(data?.id);
    toggleModal('delete');
  };
  const ActionData: IActionData<ITableData>[] = [
    {
      label: <i className="fas fa-edit" />,
      className: 'btn btn-link',
      icon: <EditIcon />,
      title: 'edit',
      clickHandler: handleEdit,
    },
    {
      label: <i className="fas fa-trash-alt" />,
      className: 'btn btn-link border-0  py-2',
      icon: <DeleteIcon />,
      title: 'delete',
      clickHandler: ActionHandler,
    },
  ];

  const getTileClassName = (date: Date, view: string, state: IHolidayState) => {
    if (view !== 'month' || !state?.holidayList) return null;
    const checkDateInList = (dates: ITableData[], targetDate: Date) =>
      dates.some(({ holidayDate }) =>
        moment(targetDate).isSame(moment(holidayDate), 'day'),
      );
    if (date.getDay() === 0) {
      return 'react-calendar__tile--sunday';
    }

    if (checkDateInList(state?.holidayList, date)) {
      return 'react-calendar__tile--holiday';
    }

    // if (checkDateInList(state?.holidayList, date))
    //   return 'react-calendar__tile--holiday';
    // return null;
  };

  const handleMonthChange = ({
    activeStartDate,
  }: {
    activeStartDate: Date | null;
  }) => {
    if (!activeStartDate) return;

    const newMonth = activeStartDate.getMonth();
    const newYear = activeStartDate.getFullYear();
    if (newYear !== selectedYear) {
      setSelectedYear(newYear);
      setSelectedMonth(newMonth);
      setPageStates((pre) => ({
        ...pre,
        startDate: moment(new Date(newYear, 0, 1)).format('YYYY-MM-DD'),
        endDate: moment(new Date(newYear, 11, 31)).format('YYYY-MM-DD'),
      }));
      return;
    }
    if (newMonth !== selectedMonth) {
      setSelectedMonth(newMonth);
      setPageStates((pre) => ({
        ...pre,
        startDate: moment(new Date(newYear, newMonth, 1)).format('YYYY-MM-DD'),
        endDate: moment(new Date(newYear, newMonth + 1, 0)).format(
          'YYYY-MM-DD',
        ),
      }));
      return;
    }
  };

  const { pageChangeHandler } = useFilter(pageStates, setPageStates);

  return (
    <>
      <Layout>
        <div className="content">
          <MainHeading
            title={'Holidays'}
            buttonText={'Add holidays'}
            buttonIcon={<PlusIcon />}
            clickHandler={toggleModal}
          />
          <CardLayout>
            <div className="row row-gap-3">
              <div className="col-12 col-lg-6 col-xl-4">
                <Calendar
                  className="table time-table"
                  onActiveStartDateChange={handleMonthChange}
                  tileDisabled={() => false}
                  tileClassName={({ date, view }) =>
                    getTileClassName(date, view, state)
                  }
                />
              </div>
              <div className="col-12 col-lg-6 col-xl-8">
                <CommonTable
                  tableHeading={tableHeading}
                  ActionData={ActionData}
                  tableData={state?.holidayList}
                  pageChangeHandler={pageChangeHandler}
                  currentPage={pageStates?.currentPage}
                  isLoading={pageStates?.tableLoader}
                  totalPages={pageStates?.totalPages}
                  count={pageStates?.count}
                  pageSize={filterDetails.pageSize}
                  handleChangePageSize={handleChangePageSize}
                />
              </div>
            </div>
          </CardLayout>
        </div>
      </Layout>
      <AddHolidayModal
        isOpen={modal?.updateData}
        onClose={() => toggleModal()}
        EditHolidaysData={state?.EditHolidaysData}
        getHoliday={getHoliday}
        setState={setState}
      />
      <ConfirmModal
        submitHandler={HandleDelete}
        isLoading={isLoading}
        toggle={() => toggleModal('delete')}
        isOpen={modal?.deleteData}
      />
    </>
  );
};

export default HolidaySetting;
